import { NgModule } from '@angular/core';
import { QpSelectComponent } from './qp-select.component';
import { UiCommonModule } from '@widgets/ui-common/ui.common.module';

@NgModule({
  declarations: [QpSelectComponent],
  exports: [QpSelectComponent],
  imports: [UiCommonModule]
})
export class QpSelectModule {}
